/**
 * PRICEUNIFY-2 · 价格表格共用样式：售价总览「按渠道看价格」、选项卡片、选项「售价」页同一套 class（表头 / 字号 / 间距 / 来源标签），改一处三处一起变。
 * 窄屏：外层 ``overflow-x-auto`` + 表格 ``min-w``，横向滚动，不换行堆叠。
 */
import type { CellSource } from "@/services/pricing";

export const PG = {
  wrap: "overflow-x-auto rounded-lg border border-slate-200",
  table: "w-full text-[13px]",
  thead: "bg-slate-50 text-[12px] font-medium text-slate-500",
  th: "px-3 py-2.5 text-left whitespace-nowrap",
  tr: "border-t border-slate-100",
  td: "px-3 py-2 tabular-nums whitespace-nowrap",
  tdMuted: "px-3 py-2 tabular-nums whitespace-nowrap text-slate-600",
} as const;

export const SRC_TAG: Record<CellSource, { label: string; cls: string }> = {
  fixed: { label: "固定", cls: "bg-blue-50 text-blue-600" },
  auto: { label: "自动", cls: "border border-slate-200 text-slate-500" },
  own: { label: "单独定价", cls: "bg-blue-50 text-blue-600" },
  follow: { label: "跟第一个", cls: "border border-slate-200 text-slate-500" },
};
export const SRC_TAG_CLS = "rounded-full px-2 py-px text-[11px]";
